<template>
  <div class="static-page">
    <atomic-page-title
      class="static-page__title"
      @on-click="router.back()"
    >
      {{ title }}
    </atomic-page-title>
    <atomic-text-editor
      v-if="currentLocaleData || defaultLocaleData"
      class="static-page__text-editor"
      :content="content"
    />

    <not-found v-else-if="status !== 'pending'" />
  </div>
</template>

<script setup lang="ts">
import type { IStaticPage } from '~/types';
import { replaceProjectName } from '@skeleton/utils/contentReplace';

const { getContent } = useProjectMethods();

const router = useRouter();
const route = useRoute();
const { pageIdentity } = route.params;

const contentParams = {
  contentKey: `${pageIdentity}-static-content`,
  contentRoute: ['static', `${pageIdentity}`],
  isPage: true,
};
const { getContentData } = useContentLogic<IStaticPage>(contentParams);
const { status, data: pageIdentityContent } = await useLazyAsyncData(pageIdentity.toString(), getContentData);

const currentLocaleData = computed(() => pageIdentityContent?.value?.currentLocaleData);
const defaultLocaleData = computed(() => pageIdentityContent?.value?.defaultLocaleData);

const title = computed(() => replaceProjectName(getContent(currentLocaleData.value, defaultLocaleData.value, 'title')));

const content = computed(() => {
  return replaceProjectName(getContent(currentLocaleData.value, defaultLocaleData.value, 'content'));
});
</script>

<style src="~/assets/styles/pages/static-page.scss" lang="scss" />
